module.exports = __webpack_public_path__ + "static/media/comment-alt-minus.a70c493a.svg";